/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ConsentInputs */

const de__field_consent = /** @type {(inputs: _Field_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zustimmung`)
};

/**

* @param {_Field_ConsentInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_consent = /** @type {((inputs?: _Field_ConsentInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ConsentInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_consent(inputs)
});